<template>
    <div class="page">
          <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="用户">
                <GridSelectU
                    style="width: 180px"
                    title="选择用户"
                    labelName="userName"
                    labelValue="id"
                    :value="queryForm.userId"
                    :limit="1"
                    size="small"
                    placeholder="请选择用户"
                    @getValue="getSearchValueUser"
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl="/mpp/user/findList"
                    entityBeanName="mppUser"
                    queryEntityUrl="/mpp/user/get"
                >
                </GridSelectU>
            </el-form-item>
            <el-form-item label="限制支付类型">
                <el-select
                    style="width: 180px"
                    size="small"
                    v-model="queryForm.limitPayModel"
                    placeholder="请选择限制支付类型"
                >
                    <el-option v-for="item in limitPayModelList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStorePayOrderList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-plus"
                        @click="showDialog = true"
                    >添加限制消费用户</el-button>
                </div>
                <div class="icon-group">
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshShopStorePayOrderList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopStorePayOrderList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size="small"
            >
                <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户id" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="phone" label="用户手机" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="limitPayModel" label="限制支付类型">
                    <template slot-scope="scop">
                        <span v-if="scop.row.limitPayModel == 1">限制全部</span>
                        <span v-if="scop.row.limitPayModel == 2">限制部分</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="canUseLimit" label="可使用额度上限" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="usedLimit" label="已使用额度" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="limitStartTime" label="限制开始时间" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="limitEndTime" label="限制结束时间" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="remark" label="备注(简短)" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="fullRemark" label="完整备注" />
                <el-table-column :show-overflow-tooltip="true" align="center" prop="updateTime" label="更新时间" />
                <el-table-column
                fixed="right"
                align="center"
                label="操作"
                >
                <template slot-scope="scop">
                    <div class="operation">
                    <div @click="deleteShopStorePayOrder(scop.row.id)">
                        <Icon size="16" style="color: red">
                        <Delete24Regular />
                        </Icon>
                        <span class="operation-label" style="color: red">删除</span>
                    </div>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 添加限制消费用户 -->
        <el-dialog
            title="添加限制消费用户"
            :visible.sync="showDialog"
            width="60%"
            @close="closeDialog"
        >
            <div>
                <el-form
                    :model="shopStorePayOrder"
                    ref="shopStorePayOrderForm"
                    :rules="rules"
                    label-width="120px"
                    :inline="true"
                    size="small"
                >
                    <el-form-item
                        label="用户"
                        prop="userId"
                    >
                        <GridSelectU
                            style="width: 180px"
                            title="选择用户"
                            labelName="userName"
                            labelValue="id"
                            :value="shopStorePayOrder.userId"
                            :limit="1"
                            size="small"
                            placeholder="请选择用户"
                            @getValueAll="getValueUser"
                            :columns="USER_code"
                            :searchs="USER_search"
                            dataListUrl="/mpp/user/findList"
                            entityBeanName="mppUser"
                            queryEntityUrl="/mpp/user/get"
                        >
                        </GridSelectU>
                    </el-form-item>
                    <el-form-item
                        label="手机号"
                        prop="phone"
                    >
                        <el-input
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.phone"
                            :disabled="true"
                            placeholder="选择用户后自动填充"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="限制支付类型"
                        prop="limitPayModel"
                    >
                       <el-select
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.limitPayModel"
                            placeholder="请选择限制支付类型"
                        >
                            <el-option v-for="item in limitPayModelList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        v-if="shopStorePayOrder.limitPayModel == 2"
                        label="可用额度"
                        prop="canUseLimit"
                    >
                        <el-input
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.canUseLimit"
                            placeholder="请输入可用额度"
                            @input="handleCanUseLimitInput"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        v-if="shopStorePayOrder.limitPayModel == 2"
                        label="已用额度"
                        prop="usedLimit"
                    >
                        <el-input
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.usedLimit"
                            placeholder="请输入已用额度"
                            @input="handleUsedLimitInput"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="限制开始时间"
                        prop="startTime"
                    >
                        <el-date-picker
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.startTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择限制开始时间"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        label="限制结束时间"
                        prop="endTime"
                    >
                        <el-date-picker
                            style="width: 180px"
                            size="small"
                            v-model="shopStorePayOrder.endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择限制结束时间"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item
                        label="备注"
                        prop="remark"
                    >
                        <el-upload 
                            :action="action" 
                            :headers="header" 
                            :before-upload="beforeImageUpload"
                            class="avatar-uploader" 
                            :show-file-list="false"
                            :http-request="uploadRemarkImage"
                        >
                            <img v-if="shopStorePayOrder.remark" :src="shopStorePayOrder.remark" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="完整备注"
                        prop="fullRemark"
                    >
                        <el-input
                            style="width: 180px"
                            size="small"
                            type="textarea"
                            :rows="3"
                            v-model="shopStorePayOrder.fullRemark"
                            placeholder="请输入完整备注"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
    
            <div
                slot="footer"
                class="flex justify-end"
            >
                <el-button @click="closeDialog">关闭</el-button>
                <el-button
                    type="primary"
                    @click="submitForm"
                >确定</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
  import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
  import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
  import { get, postJson, upload } from '@/utils/request.js';
  import GridSelectU from '@/components/gridselect/index.vue';
  import { STORE, STORE_SEARCH, USER, USER_SEARCH, UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';
  
  export default {
      components: {
          GridSelectU,
          Edit24Regular,
          Delete24Regular,
          Eye24Regular,
          GridDots,
          Refresh,
          Printer,
          ArrowUp,
          ArrowDown,
          ArrowDownload24Regular,
          ArrowExportUp24Regular,
          Search
      },
      data() {
              return {
                  queryForm:{
                       userId: '', //用户ID
                       limitPayModel: '', //限制支付类型
                  },
                  loading: false,
                  showDialog: false,
                  isSearch: false,
                  pageSize: 10,
                  currentPage: 1,
                  totalNum: 0,
                  STORE_code: STORE,
                  STORE_search: STORE_SEARCH,
                  USER_code: USER,
                  USER_search: USER_SEARCH,
                  header: {
                      token: localStorage.getItem('token')
                  },
                  action: UPLOAD_API + UPLOAD_PATH,
                  shopStorePayOrderList: [],
                  shopStorePayOrder: {
                    userId: '', //用户ID
                    phone: '', //手机号
                    limitPayModel: '', //限制支付类型
                    canUseLimit: '', //可用额度
                    usedLimit: '', //已用额度
                    startTime: '', //限制开始时间
                    endTime: '', //限制结束时间
                    remark: '', //备注
                    fullRemark: '', //完整备注
                  },
                  rules: {
                      userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                      phone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
                      limitPayModel: [{ required: true, message: '限制支付类型不能为空', trigger: 'blur' }],
                      canUseLimit: [
                          { 
                              required: true, 
                              message: '可用额度不能为空', 
                              trigger: 'blur',
                              validator: (rule, value, callback) => {
                                  if (this.shopStorePayOrder.limitPayModel == 2) {
                                      if (!value || value === '') {
                                          callback(new Error('可用额度不能为空'));
                                      } else if (isNaN(Number(value))) {
                                          callback(new Error('可用额度必须是数字'));
                                      } else {
                                          const num = Number(value);
                                          if (num < 0) {
                                              callback(new Error('可用额度不能为负数'));
                                          } else {
                                              // 检查小数位数
                                              const decimalParts = String(value).split('.');
                                              if (decimalParts.length === 2 && decimalParts[1].length > 4) {
                                                  callback(new Error('可用额度最多只能有4位小数'));
                                              } else {
                                                  callback();
                                              }
                                          }
                                      }
                                  } else {
                                      callback();
                                  }
                              }
                          }
                      ],
                      usedLimit: [
                          { 
                              required: true, 
                              message: '已用额度不能为空', 
                              trigger: 'blur',
                              validator: (rule, value, callback) => {
                                  if (this.shopStorePayOrder.limitPayModel == 2) {
                                      if (!value || value === '') {
                                          callback(new Error('已用额度不能为空'));
                                      } else if (isNaN(Number(value))) {
                                          callback(new Error('已用额度必须是数字'));
                                      } else {
                                          const num = Number(value);
                                          if (num < 0) {
                                              callback(new Error('已用额度不能为负数'));
                                          } else {
                                              // 检查小数位数
                                              const decimalParts = String(value).split('.');
                                              if (decimalParts.length === 2 && decimalParts[1].length > 4) {
                                                  callback(new Error('已用额度最多只能有4位小数'));
                                              } else {
                                                  callback();
                                              }
                                          }
                                      }
                                  } else {
                                      callback();
                                  }
                              }
                          }
                      ],
                      startTime: [{ required: true, message: '限制开始时间不能为空', trigger: 'blur' }],
                      endTime: [{ required: true, message: '限制结束时间不能为空', trigger: 'blur' }],
                      remark: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
                      fullRemark: [{ required: true, message: '完整备注不能为空', trigger: 'blur' }],
                  },
                  limitPayModelList: [{
                    value: 1,
                    label: '限制全部'
                  }, {
                    value: 2,
                    label: '限制部分'
                  }],
              };
          },
          watch: {
              'shopStorePayOrder.limitPayModel'(newVal, oldVal) {
                  // 当限制支付类型切换时，清空可用额度和已用额度
                  if (newVal !== oldVal) {
                      this.shopStorePayOrder.canUseLimit = '';
                      this.shopStorePayOrder.usedLimit = '';
                  }
              }
          },
          created() {
              this.getShopStorePayOrderList();
          },
          methods: {
            //   搜索box
              search(){
                  this.isSearch = !this.isSearch;
              },
              resetShopStorePayOrderList() {
                  this.pageSize = 10;
                  this.currentPage = 1;
                  this.shopStorePayOrderList = [];
              },
              resetDialog() {
                  this.queryForm.userId = '';
                  this.queryForm.limitPayModel = '';
                  this.getShopStorePayOrderList();
              },
              getSearchValueUser(value) {
                  this.queryForm.userId = value;
              },
              getValueUser(value) {
                  if (value) {
                      this.shopStorePayOrder.userId = value.id;
                      this.shopStorePayOrder.phone = value.userMobile || value.phone || '';
                  }
              },
              //上传备注图片
              uploadRemarkImage(params) {
                  const file = params.file;
                  let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                  if (!types.includes(file.type)) {
                      this.$message.error('图片类型错误!');
                      return;
                  }
                  const formData = new FormData();
                  formData.append('file', file);
                  upload(UPLOAD_PATH, formData).then((res) => {
                      if (res.success) {
                          this.shopStorePayOrder.remark = res.url;
                          this.$message({
                              message: '图片上传成功',
                              type: 'success',
                              duration: 2000
                          });
                      } else {
                          this.$message.error(res.msg || '图片上传失败');
                      }
                  });
              },
              beforeImageUpload(file) {
                  const isLt50M = file.size / 1024 / 1024 < 50;
                  if (!isLt50M) {
                      this.$message.error('上传图片大小不能超过 50MB!');
                  }
                  return isLt50M;
              },
              // 处理可用额度输入，限制最多4位小数
              handleCanUseLimitInput(value) {
                  // 移除所有非数字字符（除了小数点）
                  let numStr = value.replace(/[^0-9.]/g, '');
                  
                  // 处理多个小数点的情况
                  const decimalParts = numStr.split('.');
                  if (decimalParts.length > 2) {
                      numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
                  }
                  
                  // 限制小数位数最多4位
                  if (decimalParts.length === 2 && decimalParts[1].length > 4) {
                      numStr = `${decimalParts[0]}.${decimalParts[1].substring(0, 4)}`;
                  }
                  
                  // 处理以小数点开头的情况
                  if (numStr.startsWith('.')) {
                      numStr = '0' + numStr;
                  }
                  
                  this.shopStorePayOrder.canUseLimit = numStr;
              },
              // 处理已用额度输入，限制最多4位小数
              handleUsedLimitInput(value) {
                  // 移除所有非数字字符（除了小数点）
                  let numStr = value.replace(/[^0-9.]/g, '');
                  
                  // 处理多个小数点的情况
                  const decimalParts = numStr.split('.');
                  if (decimalParts.length > 2) {
                      numStr = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
                  }
                  
                  // 限制小数位数最多4位
                  if (decimalParts.length === 2 && decimalParts[1].length > 4) {
                      numStr = `${decimalParts[0]}.${decimalParts[1].substring(0, 4)}`;
                  }
                  
                  // 处理以小数点开头的情况
                  if (numStr.startsWith('.')) {
                      numStr = '0' + numStr;
                  }
                  
                  this.shopStorePayOrder.usedLimit = numStr;
              },
              closeDialog() {
                  this.showDialog = false;
                  this.shopStorePayOrder = {
                    userId: '', //用户ID
                    phone: '', //手机号
                    limitPayModel: '', //限制支付类型
                    canUseLimit: '', //可用额度
                    usedLimit: '', //已用额度
                    startTime: '', //限制开始时间
                    endTime: '', //限制结束时间
                    remark: '', //备注
                    fullRemark: '', //完整备注
                  };
              },
              submitForm() {
                this.$refs.shopStorePayOrderForm.validate((valid) => {
                    if (valid) {
                        // 构建提交数据，将数字字段转换为数字类型
                        const submitData = { ...this.shopStorePayOrder };
                        
                        // 将可用额度和已用额度转换为数字类型（如果有值）
                        if (submitData.canUseLimit !== '' && submitData.canUseLimit !== null && submitData.canUseLimit !== undefined) {
                            submitData.canUseLimit = parseFloat(submitData.canUseLimit) || 0;
                        }
                        
                        if (submitData.usedLimit !== '' && submitData.usedLimit !== null && submitData.usedLimit !== undefined) {
                            submitData.usedLimit = parseFloat(submitData.usedLimit) || 0;
                        }
                        
                        postJson(`/payLimit/insert`, submitData).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopStorePayOrderList();
                                this.closeDialog();
                                this.getShopStorePayOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
              },
            //   删除
              deleteShopStorePayOrder(id) {
                  this.$confirm('确定删除所选项吗？', '提示', {
                      type: 'warning'
                  })
                      .then(() => {
                          get(`/payLimit/deleteByld`,{ id:id }).then((res) => {
                              if (res.success) {
                                  this.$message({
                                      message: res.msg,
                                      type: 'success',
                                      duration: 2000
                                  });
                                  this.resetShopStorePayOrderList();
                                  this.getShopStorePayOrderList();
                              } else {
                                  this.$message({
                                      message: res.msg,
                                      type: 'error',
                                      duration: 2000
                                  });
                              }
                          });
                      })
                      .catch(() => {});
              },
              refreshShopStorePayOrderList() {
                  this.resetShopStorePayOrderList();
                  this.getShopStorePayOrderList();
              },
            //   获取列表信息
              getShopStorePayOrderList() {
                  this.loading = true;
                  postJson(`/payLimit/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                      this.loading = false;
                      if (res.success) {
                          this.shopStorePayOrderList = res.list.list;
                          this.totalNum = res.list.total;
                      } else {
                          this.$message({
                              message: res.msg,
                              type: 'error',
                              duration: 2000
                          });
                      }
                  });
              },
              currentChange(page) {
                  this.currentPage = page;
                  this.getShopStorePayOrderList();
              },
              sizeChange(size) {
                  this.pageSize = size;
                  this.getShopStorePayOrderList();
              }
          }
  
  };
  </script>
  
  <style lang="scss" scoped>
  ::v-deep .el-dialog__header {
      border-bottom: 1px solid #eee;
  }
  .operation {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #409eff;
      font-size: 12px;
  
      & > div {
          display: flex;
          align-items: center;
          padding: 0 5px;
          cursor: pointer;
      }
  
      .operation-label {
          margin-left: 3px;
      }
  }
  .count{
      font-size: 14px;
      margin-left: 10px;
      padding: 0 4px;
  }
  ::v-deep .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 178px;
      height: 178px;
  }
  ::v-deep .avatar-uploader .el-upload:hover {
      border-color: #409eff;
  }
  .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
  }
  .avatar {
      width: 178px;
      height: 178px;
      display: block;
  }
  </style>